import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// 전화번호 인증(SMS) 전용 Firebase 초기화.
// 이 프로젝트의 데이터는 REST API(ddukddaki.com:4989)를 사용하고,
// Firebase 는 오직 휴대폰 전화인증(signInWithPhoneNumber) 용도로만 사용한다.
const firebaseConfig = {
  apiKey: "AIzaSyDEhpMZWsUO755d9V8xnYBdE-0hxb1vc-g",
  authDomain: "ddukddaki.com",
  projectId: "farm-fc27c",
  storageBucket: "farm-fc27c.firebasestorage.app",
  messagingSenderId: "55593737743",
  appId: "1:55593737743:web:990e8dc44bf964648d4d7a",
  measurementId: "G-3PM2793TWD",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
